import gql from 'graphql-tag';

import type { BlogOutlineSection } from 'src/data/blog';
import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION } from './schema';

const MUTATION = gql`
  mutation CreateBlogPostBuilderOutlineSection(
    $projectId: ID!
    $draftId: ID!
    $headline: String!
    $order: Int!
    $afterSectionId: ID
    $instructions: String
  ) {
    createBlogPostBuilderOutlineSection(
      projectId: $projectId
      draftId: $draftId
      headline: $headline
      order: $order
      afterSectionId: $afterSectionId
      instructions: $instructions
    ) {
      ...BlogPostBuilderOutlineSection
    }
  }
  ${FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION}
`;

interface Params {
  projectId: ID;
  draftId: ID;
  headline: string;
  order: number;
  afterSectionId: ID;
  instructions: string;
}

export const createBlogPostBuilderOutlineSection = async ({
  projectId,
  draftId,
  headline,
  order,
  afterSectionId,
  instructions,
}: Params) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { projectId, draftId, headline, order, afterSectionId, instructions },
  });

  return getSingleProp<BlogOutlineSection>(result.data);
};
